(function () {

seedWebApp.controller('StageAlternativeApprovalModalCtrl', StageAlternativeApprovalModal);

    function StageAlternativeApprovalModal(item, translation, isEdit, UserSettingService, ToastService, HelpdeskService, $uibModalInstance, $uibModal) {
        var ctrl = this;

        ctrl.item = item;
        ctrl.translation = translation;
        ctrl.isEdit = isEdit;

        ctrl.searchApprovalUsers = function () {
            return UserSettingService.getApprovalUsers()
                .then(function (response) {
                    ctrl.names = response.data.map(function (value) {
                        return {
                            Key: value,
                            Value: value,
                        }
                    });
                });
        }

        ctrl.addAlternativeApproval = function () {
            HelpdeskService.addAlternativeApproval(ctrl.item).then(function (response) {
                successToast('Aprovador Alternativo Adicionado');
                $uibModalInstance.close();
            })
                .catch(function (error) {
                    var errMsg = ToastService.getErrorMsg(error);
                    errorToast('Error: ' + errMsg);
                })
        }

        ctrl.updateAlternativeApproval = function () {
            HelpdeskService.updateAlternativeApproval(ctrl.item).then(function (response) {
                successToast('Aprovador alternativo atualizado');
                $uibModalInstance.close();
            })
                .catch(function (err) {
                    var errMsg = ToastService.getErrorMsg(err);
                    errorToast('Erro ao Atualizar ' + errMsg);
                })
        }

        ctrl.deleteAlternativeApproval = function () {
            modalDeleteResult(openModalDelete());
        }

        function modalDeleteResult(modalInstance) {
            modalInstance.result.then(function (response) {
                if (response == 'true') confirmDeleteDoc();
            });
        }

        function confirmDeleteDoc() {
            HelpdeskService.deleteAlternativeApproval(ctrl.item.AlternativeApprovalID)
                .then(function (response) {
                    successToast('Alternative Approver Removido.');
                    $uibModalInstance.close();
                })
                .catch(function (error) {
                    var errMsg = ToastService.getErrorMsg(error);
                    errorToast('Erro ao Remover ' + errMsg);
                });
        }

        function openModalDelete() {
            return $uibModal.open({
                templateUrl: './SPA/Shared/delete-modal.html' + seedWebApp.buildVersion,
                controller: 'DeleteModalCtrl as ctrl',
                size: 'md',
                resolve: {
                    translation: function () {
                        return ctrl.translation;
                    },
                }
            });
        }

        ctrl.searchUsers = function () {
            var query = '';
            return UserSettingService.getUsersQuery(query)
                .then(function (response) {
                    ctrl.users = response.data.map(function (item) {
                        return {
                            Key: item.Key,
                            Value: item.Key,
                        };
                    });
                })
        };

        ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        ctrl.searchApprovalUsers();
        ctrl.searchUsers();

        function successToast(msg) {
            ToastService.createToast(ctrl.translation.Success, msg, 8000, 'success');
        }

        function errorToast(error) {
            ToastService.createToast(ctrl.translation.Error, error, 0, 'error');
        }
    }
})();